// @flow
/** @jsx jsx */

import { jsx } from '@emotion/core';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

type State = {
  show: boolean,
  done: boolean
};

type Props = {
  active?: boolean,
  text?: string,
  container: any,
  delay?: number,
  startWhen?: boolean
};

export default class Curtain extends React.Component<Props, State> {
  timer: TimeoutID;
  timerCleaner: TimeoutID;

  state = {
    show: false,
    done: false,
  };

  static defaultProps = {
    show: false,
    text: 'Restoring state',
    delay: 200,
    startWhen: true
  };

  oldDerivedStateFromProps(nextProps: Props) {
    if (!nextProps.active) {
      return this.setState({
        show: false,
        done: false
      });
    }

    return null;
  }

  componentDidMount() {
    this.oldDerivedStateFromProps(this.props)
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props !== prevProps) {
      this.oldDerivedStateFromProps(this.props)
    }
    if (prevState.done || !this.props.startWhen) return;

    if (this.props.active && !prevState.show) {
      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        this.setState({
          show: true,
        }, this.handleCleaningOnComplete);
      }, 10);
    } else if (!this.props.active) {
      this.clean();
    }
  }

  handleCleaningOnComplete = () => {
    if (this.timerCleaner) {
      clearTimeout(this.timerCleaner);
    }

    this.timerCleaner = setTimeout(() => {
      this.setState({
        done: true,
      }, this.clean);
    }, this.props.delay);
  }

  componentWillUnmount() {
    this.clean();
  }

  clean = () => {
    if (this.timer) {
      clearTimeout(this.timer);
    }

    if (this.timerCleaner) {
      clearTimeout(this.timerCleaner);
    }
  }

  render() {
    if (!this.props.active || this.state.done || !this.props.container) return null;

    const Comp = (
      <div
        css={{
          textAlign: 'center',
          background: 'rgba(20, 156, 130, 0.6)',
          color: 'white',
          padding: '5px',
          margin: '70px 0 5px',
        }}
      >
        {this.props.text}
      </div>
    );

    return ReactDOM.createPortal(
      <div
        css={[
          {
            width: '100%',
            height: '100%',
            background: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 100,
            opacity: 1,
            backgroundColor: 'white',
            // $FlowFixMe
            transition: `opacity ${this.props.delay}ms ease-in-out`,
          },
          this.state.show && this.props.startWhen && {
            opacity: 0,
          },
        ]}
      >
        {Comp}
      </div>,
      this.props.container,
    );
  }
}
